<wiz-hgroup width="100%" height="100%" style="overflow: hidden" padding="0" gap="0">
  <span
    [style.background]="pickedColor"
    width="100%"
    height="100%"
    [cpToggle]="true"
    [cpDialogDisplay]="'inline'"
    [cpDisableInput]="false"
    [cpCancelButton]="true"
    [cpOKButton]="true"
    cpOKButtonClass="hyperButton"
    cpCancelButtonClass="hyperButton"
    (colorPickerSelect)="setColor($event)"
    (colorPickerCancel)="hide()"
    [(colorPicker)]="pickedColor"
  ></span>
</wiz-hgroup>
